export const en = {
    mask: 'dd.mm.yyyy',
};
